import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './LoadingDiv.module.css';


export default function LoadingDiv() {
  const visible = useSelector(state => state.GlobalReducer.showLoadingDiv)

  return (
    <Backdrop className={styles.backdrop} open={visible}>
        <CircularProgress color="inherit" />
    </Backdrop>
  );
}